<template>
  <div id="app" class="app">
    <a-config-provider :locale="local">
      <component :is="layout" />
    </a-config-provider>
  </div>
</template>

<script>
import Home from '@/layout/home'
import Layout from '@/layout/layout'
import PersonalCenter from '@/layout/personal-center'
import NoLayout from '@/layout/no-layout.vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

import { mapGetters, mapMutations } from 'vuex'
import { changeThemeColor } from '@/utils/theme'

export default {
  components: {
    Home,
    Layout,
    PersonalCenter,
    NoLayout
  },

  data() {
    return {
      local: zhCN
    }
  },

  computed: {
    ...mapGetters('system', ['platformConfig']),

    // 使用个人中心layout
    layout() {
      return this.$route.meta.layout
    }
  },

  watch: {
    platformConfig: {
      handler: function(val) {
        changeThemeColor(val.theme, val.otherTheme)
      },
      immediate: false
    }
  },

  created() {
    this.setDomain(document.domain)
    document.title = this.platformConfig.title
    this.changeFavicon(this.platformConfig.favicon)
  },

  mounted() {
    const ua = navigator.userAgent.toLowerCase()
    const s = ua.match(/msie ([\d.]+)/)
    const version = s ? s[1] : 10

    if (version <= 9) {
      this.$alert('请使用IE10及以上的现代浏览器访问本网站', '系统提示', {
        confirmButtonText: '确定',
        callback: action => {
          // 跳转到微软新版浏览器页面
          window.location.href = 'https://www.microsoft.com/zh-cn/edge'
        }
      })
    }
  },

  methods: {
    ...mapMutations('system', { setDomain: 'SET_SYSTEM_DOMAIN' }),

    changeFavicon(link) {
      let $favicon = document.querySelector('link[rel="icon"]')
      if (!link) {
        const $parent = $favicon.parentElement
        $parent.removeChild($favicon)
      }
      if ($favicon !== null) {
        $favicon.href = link
      } else {
        $favicon = document.createElement('link')
        $favicon.rel = 'icon'
        $favicon.href = link
        document.head.appendChild($favicon)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
